import { render, staticRenderFns } from "./portSettle.vue?vue&type=template&id=265de1c0&scoped=true&"
import script from "./portSettle.vue?vue&type=script&lang=js&"
export * from "./portSettle.vue?vue&type=script&lang=js&"
import style0 from "./portSettle.vue?vue&type=style&index=0&id=265de1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265de1c0",
  null
  
)

export default component.exports